import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import usePagination from "../../../../../../hooks/usePagination";
import { ComplianceAPI } from "../../../../../../api/compliance";
import { complianceSearchActions } from "../../../../../../reducers/complianceSearch";
import { NAME_LIST_VALIDATION_SCHEMA } from "../../../../../../utils/validation";

import Table from "../Table";
import { SearchByListValues } from "../../../../../../components/ui";
import { useComplianceSearchContext } from "../../../../../../context";
import { SectionTitle } from "../../../../styledComponents";

const SearchAccountsByPhone = (): React.ReactElement => {
  const dispatch = useDispatch();
  const pagination = usePagination();
  const { tabsTablesSearchState, setTabsTablesSearchState } = useComplianceSearchContext();
  const { phones } = tabsTablesSearchState.allAccountSearchTab.searchAccountsByPhone.search;

  const { loading, data } = useSelector((state) => state.complianceSearch.searchOnPhoneVariations);

  const handleChangePage = (page: number) => pagination.setPage(page);

  const fetchData = async (values: { phones: string }) => {
    try {
      dispatch(complianceSearchActions.fetchByPhoneRequest());
      const query = new URLSearchParams();
      query.append("limit", pagination.limit.toString());
      query.append("page", pagination.page.toString());
      values.phones
        .trim()
        .replaceAll(", ", ",")
        .split(",")
        .forEach((value) => {
          query.append("phones", value.trim());
        });

      const response = await ComplianceAPI.getAllEntriesRequestByValues(query.toString());
      pagination.setCount(response.data.count);
      dispatch(complianceSearchActions.fetchByPhoneSuccess(response.data));
    } catch (error) {
      dispatch(complianceSearchActions.fetchByPhoneFailed());
      console.log("error SearchAccountsByPhone fetching data", error);
    }
  };

  useEffect(() => {
    (async () => {
      phones && (await fetchData({ phones }));
    })();
  }, [phones, pagination.page, pagination.limit]);

  useEffect(() => {
    pagination.setPage(0);
  }, [phones]);

  return (
    <SectionTitle title="Search on phone numbers">
      <SearchByListValues
        fetchData={(values) => {
          setTabsTablesSearchState({
            ...tabsTablesSearchState,
            allAccountSearchTab: {
              ...tabsTablesSearchState.allAccountSearchTab,
              searchAccountsByPhone: {
                search: { phones: values.phones },
              },
            },
          });
        }}
        isLoading={false}
        name="phones"
        label="Phone numbers"
        placeholder="+3..., +6..., e.t.c ..."
        initialValues={{ phones }}
        validationSchema={NAME_LIST_VALIDATION_SCHEMA}
      />

      <Table
        handleChangePage={handleChangePage}
        pagination={pagination}
        data={data}
        loading={loading}
        table_name="E2T All accounts search - Search on phone numbers"
      />
    </SectionTitle>
  );
};

export default SearchAccountsByPhone;
